module.exports = "/_next/static/images/0d541a7325017d81a1cd963fdc541972-Nubank_HickDuarte_57380_xs.png";